module.exports = __webpack_public_path__ + "static/media/banff-bg-graphic-texture.f8500762.svg";